module.exports = __webpack_public_path__ + "img/win.322f5437.png";